import { render, staticRenderFns } from "./Module.vue?vue&type=template&id=98371f34&scoped=true&"
import script from "./Module.vue?vue&type=script&lang=js&"
export * from "./Module.vue?vue&type=script&lang=js&"
import style0 from "./Module.vue?vue&type=style&index=0&id=98371f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98371f34",
  null
  
)

export default component.exports